






































import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';

@Component({
  components: {
    MainButton,
    LabelSlot,
  },
})
export default class PerformBillingConfirmSingleModal extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  loading: boolean = false;

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalBillingConfirmSingleExecution', value);
  }

  startLoading(): void {
    this.loading = true;
  }

  stopLoading(): void {
    this.loading = false;
  }

  handleBillingSingleExecution() {
    this.showModal = false;
    this.$emit('executeBillingConfirmSingleExecution', true);
  }
}
